/**
 * Central logger: no-op in production to avoid leaking data and reducing noise.
 * In development, forwards to console. Can be extended to send errors to Sentry/AppInsights.
 */
const isDev = process.env.NODE_ENV !== 'production';

const noop = () => {};

export const logger = {
    log: isDev ? (...args) => console.log(...args) : noop,
    warn: isDev ? (...args) => console.warn(...args) : noop,
    error: isDev ? (...args) => console.error(...args) : noop,
    debug: isDev ? (...args) => console.debug(...args) : noop,
};

/**
 * Audit-style log for significant actions (login, logout, entity create/update/delete).
 * No sensitive payloads. In production can be wired to a backend or analytics.
 */
export function auditLog(actionType, meta = {}) {
    if (!isDev) return;
    const entry = { ts: new Date().toISOString(), action: actionType, ...meta };
    logger.log('[Audit]', entry);
}

export default logger;
